import { v4 as uuidV4 } from 'uuid';
import type { Clothes } from 'contracts/Clothes';

import baixo01 from 'assets/images/products/baixo_01.jpg';
import baixo02 from 'assets/images/products/baixo_02.jpg';
import baixo03 from 'assets/images/products/baixo_03.jpg';
import baixo04 from 'assets/images/products/baixo_04.jpg';

export const clothes: Clothes[] = [
  {
    id: uuidV4(),
    name: 'Calça de couro',
    image: baixo01,
    price: 'R$ 1.350',
    url: 'https://produto.mercadolivre.com.br/MLB-2219830877-calca-feminina-slim-couro-legitimo-_JM?searchVariation=174348325265#searchVariation=174348325265&position=8&search_layout=grid&type=item&tracking_id=0e0865ba-39dd-4887-b79e-a45a31dc219e',
  },
  {
    id: uuidV4(),
    name: 'Calça jeans',
    image: baixo02,
    price: 'R$ 229,90',
    url: 'https://produto.mercadolivre.com.br/MLB-2182092610-calca-jeans-wide-leg-c4-western-_JM?searchVariation=174216369460#searchVariation=174216369460&position=33&search_layout=grid&type=item&tracking_id=cab18ad8-c8df-41e5-9432-ee29c14295dd',
  },
  {
    id: uuidV4(),
    name: 'Saia de veludo cotelê',
    image: baixo04,
    price: 'R$ 127,20',
    url: 'https://produto.mercadolivre.com.br/MLB-2173918409-saia-cintura-alta-de-veludo-cotel-_JM',
  },
  {
    id: uuidV4(),
    name: 'Saia de tule',
    image: baixo03,
    price: 'R$ 249',
    url: 'https://produto.mercadolivre.com.br/MLB-1728522788-saia-midi-feminina-renda-tule-babado-elegante-luxo-princesa-_JM?searchVariation=69322987984#searchVariation=69322987984&position=32&search_layout=grid&type=item&tracking_id=70040bfd-bbfb-4e5c-8dcc-67485f9fa957',
  },
];
